export const RESPONSE_CODES = {
    UNAUTHORIZED: 401,
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    FORBIDDEN: 403,
    OK: 200,
    CONFLICT: 409
};

export const UNAUTHORIZED_RESPONSE_MESSAGE = 'Unauthorized';
